/**
 * Created by JasonChou on 17/6/19.
 */
import React, {PureComponent} from 'react'
import {merge} from'../utils/uiUtils'
export default class Input extends PureComponent {
    render() {
        const {style, ...other} = this.props;

        const newStyle = {};

        return <input type="text"  style={merge(newStyle, style)} {...other}/>
    }
}


// WEBPACK FOOTER //
// ./src/components/Input.js